import React from 'react';
import MasterMaintenance from './MasterMaintenance';

const ExceptionMaintenance = props => {
  return <MasterMaintenance isException />;
};

export default ExceptionMaintenance;
